import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, PHONE, IMAGES } from "../lib/api";
import { useSEO } from "../lib/useSEO";
import { Reveal } from "../components/Reveal";
import { Breadcrumbs, CtaBand, ICONS } from "../components/Shared";
import { BrandMarquee, PhoneBox } from "../components/Layout";
import { ArrowUpRight, Wrench } from "lucide-react";

const IMG = [IMAGES.van, IMAGES.techHandle, IMAGES.cylinder, IMAGES.handleDark, IMAGES.tech, IMAGES.techHandle, IMAGES.cylinder];

export default function ServicesIndex() {
  const [services, setServices] = useState([]);
  useSEO({ title: "Nos services de serrurerie en Seine-et-Marne (77) | Dépannage, ouverture, blindage", description: `Découvrez tous nos services de serrurerie dans le 77 : dépannage urgence, ouverture de porte, changement de serrure, blindage. Intervention 7j/7 ☎ ${PHONE}.`, path: "/services" });
  useEffect(() => { api.get("/services").then(r => setServices(r.data)).catch(() => {}); }, []);

  return (
    <div className="bg-white">
      <section className="relative pt-32 pb-16 sm:pt-36 hero-grid">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <Breadcrumbs items={[{ label: "Accueil", to: "/" }, { label: "Services" }]} />
          <Reveal>
            <p className="overline mb-4">Prestations serrurerie</p>
            <h1 className="text-4xl sm:text-6xl font-display font-semibold tracking-tighter leading-[0.95] max-w-4xl text-zinc-900">Nos services de serrurerie en Seine-et-Marne</h1>
            <p className="text-lg text-zinc-600 mt-8 max-w-2xl leading-relaxed">Du dépannage d'urgence à la sécurisation complète de votre domicile, nos serruriers interviennent dans tout le département 7j/7 et 24h/24.</p>
            <div className="mt-8"><PhoneBox /></div>
          </Reveal>
        </div>
      </section>
      <BrandMarquee />
      <section className="relative z-10 py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s, i) => {
            const Icon = ICONS[s.icon] || Wrench;
            return (
              <Reveal key={s.slug} delay={(i % 3) * 0.06}>
                <Link to={`/services/${s.slug}`} data-testid={`service-card-${s.slug}`} className="group block h-full card-soft overflow-hidden rounded-2xl border border-zinc-200 bg-white shadow-sm">
                  <div className="relative h-44 overflow-hidden">
                    <img src={IMG[i % IMG.length]} alt={`${s.name} SERRURERIE 77`} className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-700" />
                    <div className="absolute inset-0 bg-gradient-to-t from-zinc-950/50 to-transparent" />
                    {s.priority && <span className="absolute top-4 left-4 rounded-full bg-primary px-3 py-1 text-[11px] font-semibold uppercase tracking-wider text-white">Urgence n°1</span>}
                  </div>
                  <div className="p-7">
                    <Icon className="h-7 w-7 text-primary mb-4" />
                    <h2 className="text-2xl font-display font-medium text-zinc-900">{s.name}</h2>
                    <p className="text-sm text-zinc-500 mt-1">{s.tagline}</p>
                    <p className="text-zinc-600 mt-4 text-sm leading-relaxed line-clamp-3">{s.intro}</p>
                    <span className="mt-5 inline-flex items-center gap-1.5 text-sm text-zinc-600 group-hover:text-primary transition-colors">En savoir plus <ArrowUpRight className="h-4 w-4" /></span>
                  </div>
                </Link>
              </Reveal>
            );
          })}
        </div>
      </section>
      <CtaBand />
    </div>
  );
}
